import { MarketerProductsColumnKeys } from '../declarations/marketerProducts/marketerProducts';
import { MarketersListColumnKeys } from '../declarations/marketersList/marketersList';
import {
    Marketer,
    MarketerAccess,
    MarketerProduct,
    ServerMarketer,
    ServerMarketerAccess,
    ServerMarketerProduct
} from '../typings/marketers';

export const MarketersHelper = {
    getProduct: (product: ServerMarketerProduct): MarketerProduct => {
        return {
            id: product.productId.toString(),
            productName: product.productName,
            access: MarketersHelper.getAccess(product.accessType)
        };
    },
    getMarketer: (marketer: ServerMarketer): Marketer => {
        return {
            id: marketer.clientId.toString(),
            login: marketer.productLogin,
            fullName: marketer.username,
            ownProducts: marketer.availableProducts.map(
                (product: ServerMarketerProduct): MarketerProduct =>
                    MarketersHelper.getProduct(product)
            )
        };
    },
    getServerAccess: (access: MarketerAccess): ServerMarketerAccess => {
        if (access === MarketerAccess.canRead) {
            return ServerMarketerAccess.canRead;
        }

        return ServerMarketerAccess.canWrite;
    },
    getAccess: (access: ServerMarketerAccess): MarketerAccess => {
        if (access === ServerMarketerAccess.canRead) {
            return MarketerAccess.canRead;
        }

        return MarketerAccess.canWrite;
    }
};

export const routeMarketersToKeyMap = {
    [MarketersListColumnKeys.ID]: (item: Marketer): string => item.id,
    [MarketersListColumnKeys.LOGIN]: (item: Marketer): string => item.login,
    [MarketersListColumnKeys.FULL_NAME]: (item: Marketer): string =>
        item.fullName
};

export const routeMarketerProductsToKeyMap = {
    [MarketerProductsColumnKeys.ID]: (item: MarketerProduct): string => item.id,
    [MarketerProductsColumnKeys.PRODUCT_NAME]: (
        item: MarketerProduct
    ): string => item.productName
};
